import { createServiceAction } from '../util/actionHelper.js';
import { apiConfig } from '../configs/apiConfig.js';
import { postRequest, displayMessage } from '../util/index.js';
import { getHTTPStatusValidationMessage, getServerValidationMessage } from '../services/serverValidations.js';
import { put, takeEvery, call } from 'redux-saga/effects';

function* listener(serviceType, action) {
  try {
    yield put(createServiceAction(serviceType, 'loading')());
    const options = action.data.formValues;
    const url = apiConfig.sendBulkEmail.endPointUrl;
    const res = yield call(postRequest, url, options);
    const statusErrorMessage = yield call(getHTTPStatusValidationMessage, res);
    if (!statusErrorMessage) {
      const response = yield res.json();
      const serverErrorMessage = yield call(getServerValidationMessage, response);
      if (!serverErrorMessage && response.errorCode === 0) {
        yield put(createServiceAction(serviceType, 'success')(response));
        yield call(displayMessage, 'success', `${response.message}`, 5000);
      }
    }
  } catch (e) {
    yield put(createServiceAction(serviceType, 'error')(e));
  }
}

function* sendBulkEmailSagas() {
  const serviceType = 'sendBulkEmail';
  yield takeEvery(createServiceAction(serviceType, 'requested').type, listener, serviceType);
}

export default sendBulkEmailSagas;
